
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-creations",
      function () {
        return require("private-next-pages/my-creations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-creations"])
      });
    }
  